import ability from './ability'

/** App Analytics: requires explicit view-amplitude_dashboard (assigned manually or via admin roles). */
export function canAccessAmplitudeDashboard(action = 'view') {
    return ability.can(action, 'amplitude_dashboard')
}
